// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-text-highlight{font-family:'Garnett','Helvetica','Segoe UI','Arial',sans-serif;font-feature-settings:'ss01';font-size:.75rem;font-weight:400;letter-spacing:.02em;line-height:160%;padding:2px 4px}.mp-text-highlight.bold{font-weight:500}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
